import { Paper } from "@mui/material";

export default function Dashboard() {
  return <Paper>Dashboard</Paper>;
}
